export const environment = {
  production: true,
  seed: 'satrust-application-session.seed.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts